export default __webpack_public_path__ + "static/media/AD-DAP_Data_Use_Agreement_and_Terms_and_Conditions_2022.c177df6b.pdf";